<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Blocklist</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{ countFilter }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Blocklist</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }} {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{ labelName }}</th>
                    <th scope="col" class="border-0">{{ labelIdentity }}</th>
                    <th scope="col" class="border-0">{{ labelDescription }}</th>
                    <th scope="col" class="border-0">{{ labelCreatedDate }}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <!-- <th scope="col" class="border-0"></th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(blockList, index) in blocklists" :key="index">
                    <td></td>
                    <td class="text-left">{{ blockList.Name }}</td>
                    <td class="text-center">{{ blockList.Identity | identity }}</td>
                    <td class="text-center">{{ blockList.Description }}</td>
                    <td class="td-with-subs">
                      <div>{{ blockList.CreatedDate | date }}</div>
                      <span>{{ blockList.CreatedDate | date("HH:mm:ss") }}</span>
                    </td>
                    <td></td>
                    <td>
                      <div v-if="$isAuthorize('BlockList', 'Atualizar') || $isAuthorize('BlockList', 'Deletar')" class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >Opções</button>
                        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                          <a v-if="$isAuthorize('BlockList', 'Atualizar')" class="dropdown-item" href="#" v-on:click="GetUserBlockList(blockList)">
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a v-if="$isAuthorize('BlockList', 'Deletar')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="DeletarBlocklist(blockList)"
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr v-if="blocklists == undefined || blocklists == null || blocklists.length == 0">
                    <td colspan="6">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- B MODAL CRUD -->

    <b-modal id="mFilter" title="Filtros" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            :placeholder="labelName"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>

        <d-col md="6" class="form-group">
          <the-mask
            class="form-control"
            type="tel"
            :placeholder="labelIdentity"
            :mask="['###.###.###-##', '##.###.###/####-##']"
            v-model="filter.Identity"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button variant="primary" class="btn btn-primary" v-b-tooltip.hover.bottom title="Pesquisar" @click="Filter()">
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <b-modal id="mFormUserBlocklist" 
    :title="modalTitle" centered :no-close-on-backdrop="true" :no-close-on-esc="false">
    <div>
      <ValidationObserver ref="formValidation">
      <d-form-row>
        <d-col md="6" class="form-group">
          <label>Nome</label>
          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
          <d-form-input
                  :class="validatedFormValidation | showValidateError(invalid)"
                  type="text"
                  v-model="infoUserBlocklist.Name"
                  placeholder="Nome"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
                </div>
         </ValidationProvider>
        </d-col>
        <d-col md="6" class="form-group">
          <label>CPF/CNPJ</label>
          <ValidationProvider rules="required|min:11" v-slot="{ errors, invalid }">
          <the-mask
              :class="validatedFormValidation | showValidateError(invalid)"
              class="form-control"
              type="tel"
              :mask="['###.###.###-##', '##.###.###/####-##']"
              v-model="infoUserBlocklist.Identity"
              placeholder="CPF/CNPJ"
            />
            <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
            </div>
        </ValidationProvider>
        </d-col>
        <d-col md="12" class="form-group">
          <label>Descrição</label>
          <ValidationProvider rules="required" v-slot="{ errors, invalid }">
          <d-form-input
                  :class="validatedFormValidation | showValidateError(invalid)"
                  type="text"
                  v-model="infoUserBlocklist.Description"
                  placeholder="Descrição"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedFormValidation"
                >
                  {{ errors[0] }}
            </div>
          </ValidationProvider>
        </d-col>
      </d-form-row>
    </ValidationObserver>
    </div>
    <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveUserBlockList()"
          :v-if="isCreating"
        >
          {{ isCreating == false ? "Salvar" : "Adicionar" }}
          <i class="fas fa-arrow-right"></i>
        </b-button>
      </template>
    </b-modal>

    <div v-if="$isAuthorize('BlockList', 'Adicionar')">
    <a
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo Registro"
      v-on:click="OpenNewUserBlocklist()"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
  </div>
</template>

<script>
import dateField from "../common/date-field";
import { hasValue } from "../../utils/functions.js";
export default {
  name: "blockList",
  data: function() {
    return {
      loadingList: false,
      validatedFormValidation: false,
      labelName: "Nome",
      labelIdentity: "CPF/CNPJ",
      labelDescription: "Descrição",
      labelCreatedDate: "Data de criação",
      modalTitle: "Novo Registro Blocklist",
      countFilter: 0,
      filter: {
        Name: null,
        Identity: null
      },
      infoUserBlocklist: {
        Name: null,
        Identity: null,
        Description: null
        },
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      pOpened: null,
      blocklists: []
    };
  },
  components: {
    dateField
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListBlockList();
    },
    "pagination.RowsPerPage": function() {
      this.ListBlockList();
    }
  },
  mounted() {
    this.ListBlockList();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListBlockList();
    },
    ResetFilter: function() {
      this.filter = {
        Name: null,
        Identity: null
      };
      this.ListBlockList();
    },
    ListBlockList: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Name)) this.countFilter++;
      if (hasValue(this.filter.Identity)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Name": this.filter.Name,
          "Object.Identity": this.filter.Identity
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListBlocklist", { params: data })
        .then(response => {
          this.blocklists = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar a Blocklist", error);
        })
        .finally(() => (this.loadingList = false));
    },
    GetUserBlockList: function (blocklist) {
      this.loadingModal = true;
      this.isCreating = false;
      this.$store
        .dispatch("GetBlocklist", blocklist.Id)
        .then(() => {
          this.infoUserBlocklist = { ...blocklist};

          this.modalTitle = "Editar Registro Blocklist";
          
          this.ShowUserBlockList();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao carregar o registro",
            error
          );
        })
        .finally(() => {
          this.loadingModal = false;
        });
    },
    SaveUserBlockList: function () {
      this.validatedFormValidation = true;
      this.$refs.formValidation.validate().then((valid) => {
        if (valid) {
          this.AdicionarOuAtualizarBlockList();
        }
      });
    },
    AdicionarOuAtualizarBlockList: function () {
      if (this.isCreating) {
      this.$store
          .dispatch("AdicionarBlocklist", this.infoUserBlocklist)
          .then(() => {
            this.$makeToast(
              "Cadastrado corretamente na base de dados.",
              "success",
              "Registro cadastrado"
            );
            this.FeedbackUserBlockList();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao adicionar na Blocklist",
              error
            );
          })
          .finally(() => {});
      } else {
        this.$store
          .dispatch("AtualizarBlocklist", this.infoUserBlocklist)
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Registro atualizado"
            );
            this.FeedbackUserBlockList();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar o registro",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    EditarBlockList: function () {
      this.$store
          .dispatch("EditarBlocklist", {
            userInternal: this.infoUserInternal,
          })
          .then(() => {
            this.$makeToast(
              "Suas modificações foram salvas na base de dados.",
              "success",
              "Registro da Blocklist atualizado"
            );
            this.FeedbackUserBlockList();
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao atualizar registro da Blocklist",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
    },
    DeletarBlocklist: function (blocklist) {
      //let deleted = this.users[i];
      this.$store
        .dispatch("DeletarBlocklist", { id: blocklist.Id })
        .then(() => {
          this.$makeToast(
            `${blocklist.Name} foi removido dos registros da Blocklist.`,
            "success",
            "Registro removido da Blocklist"
          );
          this.FeedbackUserBlockList();
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o registro da Blocklist",
            error
          );
        });
    },
    FeedbackUserBlockList() {
      this.ListBlockList();
      this.$bvModal.hide("mFormUserBlocklist");
    },
    ShowUserBlockList: function () {
      validatedFormValidation: false,
      this.$bvModal.show("mFormUserBlocklist");
    },
    OpenNewUserBlocklist: function () {
      this.ResetInfoUserBlockList();
      this.isCreating = true;
      this.modalTitle = "Novo Registro Blocklist";
      this.ShowUserBlockList();
    },
    ResetInfoUserBlockList: function () {
      this.infoUserBlocklist = {
        Name: null,
        Identity: null,
        Description: null
      };
    }
  }
};
</script>

<style scoped>
.td-with-subs {
  display: block;
}
.td-with-subs > span {
  font-size: 10pt;
  opacity: 0.75;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/BlockLists.vue